import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const fetchDataLakeConnectorRegions = async () => fetch(
  "GET",
  qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/regions`)
);
const useDataLakeConnectorRegions = () => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ["data-lake-connector-regions"],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectorRegions(),
      "Loading Data Lake Connector Regions failed with status",
      "Could not load Data Lake Connector Regions."
    ),
    notifyOnChangeProps: ["data", "error"]
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectorRegions;
